// libraries
import React, { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import classNames from "classnames/bind";

// styles
import styles from "./styles.module.scss";

// assets
import logo from "src/assets/images/logo/logo_dark.svg";
import discoverMenu from "src/assets/images/home/discover_menu.svg";
import { BellOutline } from "src/assets/icons";

// components
import SearchBar from "./SearchBar";
import ProfileIcon from "./ProfileIcon";
import DropDown from "./DropDown";
import Notification from "src/components/Notification";

// context
import UserContext from "src/context/User";

// utils
import { logoutUser } from "src/utils/requests/logout";

const cx = classNames.bind(styles);

const Navbar = ({
  withSearchBar,
  searchTerm,
  setSearchTerm,
  mobHide,
  isSidebar,
  setIsShow,
}) => {
  const { user, isLoading, logout } = useContext(UserContext);

  const [isOpen, setIsOpen] = useState(false);

  const handleLogout = () => {
    logoutUser(user.accessToken, user.userId)
      .then((res) => {
        if (res.data.Status) {
          toast.success("Logout Successfully");
          logout();
        } else {
          toast.error(res.data.ErrorMessage);
        }
      })
      .catch((err) => {
        toast.error(err);
      });
  };

  return (
    <div className={`${styles.navbar} ${mobHide ? styles.hide : ""}`}>
      <div className={styles.wrapper}>
        <div className={styles.logo_wrap}>
          <Link to="/">
            <img src={logo} alt="logo" />
          </Link>
          {withSearchBar && (
            <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
          )}
        </div>
        <div className={cx("icon-wrapper-root")}>
          <div className={cx("notify")}>
            <span
              className={cx("icon-wrapper")}
              onClick={() => setIsOpen(true)}
            >
              <BellOutline />
            </span>
            <Notification
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              desktopWrapper={cx("desktop-wrapper")}
            />
          </div>
        </div>
        <div className={styles.links}>
          {/* <Link to="/">About Eventmoon</Link>
          <Link to="/create-event">Create an Event</Link>
          <Link to="/blogs">Blogs</Link> */}
          {!isLoading && (
            <>
              {!user ? (
                <Link className={styles.login} to="/login">
                  Log In
                </Link>
              ) : (
                <>
                  <ProfileIcon user={user} />
                  <DropDown handleLogout={handleLogout} />
                </>
              )}
            </>
          )}
        </div>
        {isSidebar && (
          <img
            className={styles.menu__icon}
            onClick={() => setIsShow(true)}
            src={discoverMenu}
            alt="hamburger"
          />
        )}
      </div>
    </div>
  );
};

export default Navbar;
